import axios from "axios";

const axiosInstances = axios.create({
  baseURL: "https://www.api.camories.kamruddin.dev/apis",
  // baseURL: "https://app.camories.in/apis",
  // baseURL: "http://localhost:8000/apis",
});

export default axiosInstances;
